interface Address {
  street: string;
  district: string;
  city: string;
  country: string;
  postalCode: string;
}

interface GeoCoordinates {
  latitude: number;
  longitude: number;
}

interface OpeningHours {
  days: string;
  hours: string;
}

interface OpeningHoursSpecification {
  dayOfWeek: string[];
  opens: string;
  closes: string;
}

interface SocialMedia {
  instagram: string;
  facebook: string;
  tiktok: string;
}

export interface BusinessData {
  name: string;
  legalName: string;
  url: string;
  logo: string;
  phone: string;
  phoneDisplay: string;
  email: string;
  address: Address;
  geo: GeoCoordinates;
  openingHours: OpeningHours[];
  openingHoursSpecification: OpeningHoursSpecification[];
  socialMedia: SocialMedia;
  specialties: string[];
  priceRange: string;
  foundingYear: number;
}

export const businessData: BusinessData = {
  name: 'DentaWista',
  legalName: 'DentaWista Dental Clinic',
  url: 'https://dentawista.com',
  logo: 'https://dentawista.com/images/logo.png',
  phone: '+905070808888',
  phoneDisplay: '+90 507 080 88 88',
  email: 'info@dentawista.com',
  address: {
    street: 'Kaptanpaşa, Darülaceze Cd. No:14',
    district: 'Şişli',
    city: 'Istanbul',
    country: 'Turkey',
    postalCode: '34384',
  },
  geo: {
    latitude: 41.0586,
    longitude: 28.9802,
  },
  openingHours: [
    { days: 'Monday-Saturday', hours: '10:00-19:00' },
  ],
  openingHoursSpecification: [
    {
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '10:00',
      closes: '19:00',
    },
  ],
  socialMedia: {
    instagram: 'https://www.instagram.com/dentawista',
    facebook: 'https://www.facebook.com/dentawista',
    tiktok: 'https://www.tiktok.com/@dentawista',
  },
  specialties: [
    'Dental Implants',
    'Hollywood Smile',
    'Dental Veneers',
    'All-on-4 Implants',
    'Root Canal Treatment',
    'Teeth Whitening',
    'Cosmetic Dentistry',
  ],
  priceRange: '$$',
  foundingYear: 2018,
};
